import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { map } from '@beef/utils';
export var FieldsProjection = /*#__PURE__*/function () {
  function FieldsProjection(value, params) {
    _classCallCheck(this, FieldsProjection);
    this.value = value;
    this.params = params;
  }
  _createClass(FieldsProjection, [{
    key: "evaluate",
    value: function evaluate(ctx) {
      return map(this.value, function (value) {
        return value.evaluate(ctx);
      });
    }
  }]);
  return FieldsProjection;
}();